import Bidisha from "../../assets/teamphoto/bidisha.png";
import Cora from "../../assets/teamphoto/cora.jpg";
import Stacy from "../../assets/teamphoto/stacy.png";
import Jackie from "../../assets/teamphoto/jackie.png";
import Aaron from "../../assets/teamphoto/aaron.png";

export default [


    {
        id: 1,
        url: "problem",
        name: "Aaron Bishop",
        role: "Project Manager",
        photo: Aaron,
        linkedin: 'https://www.linkedin.com/in/aarongbishop/',
        info: "Passionate about UX strategy and came to Carnegie Mellon after 5 years as a " +
            "management and strategy consultant. I view UX as a powerful form of applied psychology."
    },

    {
        id: 2,
        url: "problem",
        name: "Bidisha Roy",
        role: "Product Designer",
        photo: Bidisha,
        linkedin: 'https://www.linkedin.com/in/bidisha-roy/',
        info: "Interaction designer with a background in human factors psychology; " +
            "I care deeply about usability and inclusivity. I spent the past 3 years " +
            "working in usability consulting and UX research for medical devices and health IT."
    },


    {
        id: 3,
        url: "problem",
        name: "Cora Wang",
        role: "UX Engineer",
        photo: Cora,
        linkedin: 'https://www.linkedin.com/in/corawang',
        info: "UX engineer with a background in Neuropsychology and Computer Science. " +
            "I am interested in how to augment the ability of technologies with good designs and bring" +
            " designs into actionable reality."
    },

    {
        id: 4,
        url: "problem",
        name: "Jackie Hu",
        role: "UX Designer",
        photo: Jackie,
        linkedin: 'https://www.linkedin.com/in/jackie-hu-025205134/',
        info: "UX designer with a background in Interactive Media Arts. My passion lies " +
            "in making impactful designs with new emerging technologies."
    },

    {
        id: 5,
        url: "problem",
        name: "Stacy Kellner",
        role: "Research Lead",
        photo: Stacy,
        linkedin:'https://www.linkedin.com/in/stacy-kellner-09995093/',
        info: "Has a cognitive science degree and an interdisciplinary background in design" +
            " consulting, media art, and the outdoor industry. I care about creativity and " +
            "diverse points of view."
    },



];
